import React from 'react';
import { motion } from 'framer-motion';
import { FiBriefcase, FiCalendar, FiMapPin } from 'react-icons/fi';
import { experiences } from '../data/portfolioData';

const toFileName = (title) =>
  title.toLowerCase().replace(/\s+/g, '-') + '.js';

const Experience = () => {
  return (
    <section id="experience" className="experience">
      <motion.h2
        className="section-comment"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {'// experience'}
      </motion.h2>
      <motion.p
        className="section-subtitle"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        My professional journey and the companies I've worked with
      </motion.p>

      <div className="timeline">
        <div className="timeline-line" />

        {experiences.map((exp, index) => (
          <motion.div
            className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
            key={index}
            initial={{ opacity: 0, x: index % 2 === 0 ? -60 : 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: index * 0.15 }}
          >
            <div className="timeline-dot" />

            <div className="experience-card">
              <div className="exp-file-tab">{toFileName(exp.title)}</div>
              <div className="exp-card-body">
                <h3 className="exp-title">{exp.title}</h3>
                <p className="exp-company">
                  <FiBriefcase /> {exp.company}
                </p>
                <p className="exp-period">
                  <FiCalendar /> {exp.period}
                </p>
                <span className={`type-badge ${exp.type}`}>
                  <FiMapPin /> {exp.type === 'remote' ? 'Remote' : 'Onsite'}
                </span>
                <p className="exp-description">{exp.description}</p>
                <div className="exp-technologies">
                  {exp.technologies.map((tech) => (
                    <span className="tech-tag" key={tech}>
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
